// extracted by mini-css-extract-plugin
export default {"textEffect":"H1TextEffect_textEffect__62H7i","gradientShift":"H1TextEffect_gradientShift__hP7r7"};